export default __webpack_public_path__ + "static/media/streamer_avatar11.a63ba725.png";